import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { RG, Radio } from '@crazyegginc/hatch';

import { AUDIENCE_METADATA } from '../../../metadata';
import { ConditionTooltip } from '../ConditionTooltip';

import { ReactComponent as TickIcon } from '@crazyegginc/hatch/dist/images/icon-tick-circle-filled.svg';

export function RadioValue({ index, innerIndex }) {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const condition = values.conditions[index];
  const { criteria, rows } = condition;
  const row = rows[innerIndex];
  const v = row.values;
  const showTooltip = row.tooltip === 'value';
  const isTouched = touched?.conditions?.[index]?.rows?.[innerIndex]?.values;
  const error = errors?.conditions?.[index]?.rows?.[innerIndex]?.values;
  const isError = isTouched && error;

  const metadata = AUDIENCE_METADATA[criteria];
  const { options } = metadata;

  function onTooltipDismiss() {
    setFieldValue(`conditions[${index}].rows[${innerIndex}].tooltip`, false, false);
  }

  function onValueChange(newValue) {
    if (showTooltip) {
      onTooltipDismiss();
    }
    setFieldValue(`conditions[${index}].rows[${innerIndex}].values`, newValue);
  }

  return (
    <div className="flex flex-col">
      <RG className="flex flex-wrap gap-y-2.5" value={v} onChange={onValueChange}>
        {options.map(({ label, value }, index) => {
          const selected = v === value;
          const option = (
            <Radio
              value={value}
              key={value}
              className={classNames('mr-2.5 flex h-[35px] items-center rounded border px-2.5 cursor-pointer', {
                'border-mystic-500': !isError && !selected,
                'border-dodger-blue-500': !isError && selected,
                'border-carnation-500': isError,
                'bg-solitude-500': selected,
                'bg-white': !selected,
              })}
            >
              {selected ? (
                <TickIcon className="h-3.5 w-3.5 fill-current text-dodger-blue-500" />
              ) : (
                <div className="h-3.5 w-3.5 rounded-full border border-cadet-blue-500" />
              )}
              <span className={classNames('text-body-2 ml-2.5', { 'text-dodger-blue-500': selected })}>{label}</span>
            </Radio>
          );

          return (
            <ConditionTooltip
              criteria={metadata}
              key={value}
              show={showTooltip && index === options.length - 1}
              onDismiss={onTooltipDismiss}
            >
              {option}
            </ConditionTooltip>
          );
        })}
      </RG>
      {isError && <div className="text-body-4 whitespace-nowrap text-carnation-500">{error}</div>}
    </div>
  );
}
